const initial_state = {
    open: false,
    loading: false,
    error_code: null,
    errors: [],
    parentPath: null,
    user_id: null,
};
export const addDeviceDialog = (state = initial_state, action) => {
    switch (action.type) {
        case 'ADD_DEVICE__REQUEST':
            return {
                ...state,
                loading: true,
                error_code: null,
                errors: [],
            };
        case 'ADD_DEVICE__OK':
            return {
                ...state,
                open: false,
                loading: false,
                error_code: null,
                errors: [],
            };
        case 'ADD_DEVICE__FAIL':
            return {
                ...state,
                loading: false,
                error_code: action.error_code,
                errors: action.errors,
                error_additional_fields: action.error_additional_fields,
            };
        case 'ADD_DEVICE_IN_GROUP_OPEN':
            return {
                ...state,
                open: true,
                parentPath: action.parentPath,
            };
        case 'CLEAR_DEVICE__FAILS':
            return {
                ...state,
                error_code: null,
                errors: [],
            };
        default:
            return state;
    }
};
